import React, { Fragment, useState, useEffect } from "react";
import colors from "react-multi-date-picker/plugins/colors";
import SelectReact from "react-select";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Select(props) {
  const { form, field } = props;
  useEffect(() => {
    if (field.value != undefined && props.options) {
      setSelected(
        props.options &&
          props.options.filter((item) => item.value == field.value)[0]
      );
    }
  }, [props.options]);

  const [selected, setSelected] = useState([]);
  const onChangeHandler = (item) => {
    if (!item) {
      form.setFieldValue(field.name, null);
      setSelected(null);
      if (props.alsoOnchange) {
        props.alsoOnchange(null);
      }
      return;
    }
    form.setFieldValue(field.name, item.value);
    setSelected(item);
    if (props.alsoOnchange) {
      props.alsoOnchange(item.value);
    }
  };

  return (
    <div
      className="text-sx col-span-2"
      style={{ zIndex: 99, position: "relative" }}
    >
      <label
        className="block uppercase text-blueGray-600 text-xs font-bold mb-2 text-white"
        htmlFor={field.name}
      >
        {props.label}
      </label>
      <SelectReact
        className={"!bg-[#313a55]"}
        placeholder="انتخاب..."
        value={props.options.filter((option) => option === selected)}
        onChange={onChangeHandler}
        options={props.options}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({
            ...base,
            zIndex: 9999,
            backgroundColor: "#313a55",
          }),
          menu: (base) => ({
            ...base,
            backgroundColor: "#313a55",
          }),
          option: (base, { isSelected }) => ({
            ...base,
            backgroundColor: isSelected ? "#404a66" : "#313a55",
            color: "#ffffff",
            "&:hover": {
              backgroundColor: "#404a66",
            },
          }),
          control: (base) => ({
            ...base,
            backgroundColor: "#313a55",
            color: "#ffffff",
          }),
          singleValue: (base) => ({
            ...base,
            color: "#ffffff",
          }),
          input: (base) => ({
            ...base,
            color: "#ffffff",
          }),
          placeholder: (base) => ({
            ...base,
            color: "#a0aec0",
          }),
        }}
        isClearable={true}
      />
      <span className="text-xs text-red-400 ">{form.errors[field.name]}</span>
    </div>
  );
}
